import { api } from '@/shared/api/client';
import type { ApprovalMappingDocument } from '@/shared/config/approval.mapping';

/**
 * Parametrização do evento, direto do banco.
 *
 * A rota **não** exige sessão: é o que permite a tela de login se identificar pelo
 * nome do evento (ver `useEventIdentity`). Também não pede `skipAuth` — quando há
 * sessão as credenciais vão pelo interceptor, e quando não há a requisição sai sem
 * elas. Os dois casos são aceitos.
 */
export async function fetchApprovalConfig(miceEventId: number, signal?: AbortSignal): Promise<ApprovalMappingDocument> {
  const { data } = await api.get<ApprovalMappingDocument>('/approval/config', {
    params: { miceEventId },
    ...(signal ? { signal } : {}),
  });

  return data;
}
